'use client';
import React from 'react';
import styles from '@/app/(pages)/home/components/new/BusinessSection/BusinessSection.module.css';
import { handleScroll } from '@/lib/utils/scroll';
import IconReact from '@/components/ui/Icon/IconReact';

export const BtnContent = () => {
    return (
        <div className={styles.buttonsContainer}>
            <div className={`${styles.ctaButtonWrapper} group`}>
                <button
                    className={styles.ctaButton}
                    onClick={() => handleScroll('cta-section', 100)}
                >
                    <div className={styles.ctaButtonShine}></div>
                    <span className={styles.ctaButtonText}>Начать сотрудничество</span>
                    <IconReact name="ArrowForward" className={styles.ctaButtonIcon} />
                </button>
            </div>
            <button className={styles.secondaryButton}>
                <span>Узнать больше</span>
            </button>
        </div>
    );
};
